export interface ECGLeadConfig {
  name: string
  data: number[]
  highlight: boolean
  onClick: () => void
}

export const ECG_LEAD_ORDER = {
  lead_i: 0,
  lead_ii: 1,
  lead_iii: 2,
  lead_avr: 3,
  lead_avl: 4,
  lead_avf: 5,
  lead_v1: 6,
  lead_v2: 7,
  lead_v3: 8,
  lead_v4: 9,
  lead_v5: 10,
  lead_v6: 11
}

export type ECGLeadName = keyof typeof ECG_LEAD_ORDER

/**
 * Configuração das 12 derivações padrão de ECG
 * Organizado em 3 canais de 4 derivações cada + 1 canal de ritmo (DII longo)
 * Usa os nomes das propriedades do ecg_raw_data
 */
export const ECG_LEAD_CHANNELS = {
  CHANNEL_1: ['lead_i', 'lead_avr', 'lead_v1', 'lead_v4'],
  CHANNEL_2: ['lead_ii', 'lead_avl', 'lead_v2', 'lead_v5'],
  CHANNEL_3: ['lead_iii', 'lead_avf', 'lead_v3', 'lead_v6'],
  RHYTHM: ['lead_ii'] // Derivação de ritmo (DII longo)
}

export const RHYTHM_STRIP_HEIGHT = 120
export const STANDARD_LEAD_HEIGHT = 100
